import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import { grey } from "@mui/material/colors";

const SoTracker = () => {
	return (
		<Stack width="90vw" margin="auto" height="80vh" alignItems="center" spacing={2} sx={{ backgroundColor: grey[200] }}>
			<iframe
				width="100%"
				view
				height="100%"
				src="https://lookerstudio.google.com/embed/reporting/9de4344c-605f-4958-a8a4-b633dd1f5462/page/c2P1"
				frameborder="0"
				style={{ border: 0 }}
				allowfullscreen
				sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe>
		</Stack>
	);
};

export default SoTracker;
